import type {
  InstructionMeta,
  InstructionRegistry,
  ProgramMeta,
} from "./types";
import { discriminatorToHex } from "./idlParser";

// To register your Anchor program IDLs, import them here and call parseIdl():
//
// import { parseIdl } from "./idlParser";
// import myProgramIdl from "@/idl/my_program.json";

function buildRegistry(): InstructionRegistry {
  const registry: InstructionRegistry = new Map();

  // TODO: Import your Anchor IDLs and register them here:
  // import myProgramIdl from "@/idl/my_program.json";
  // const meta = parseIdl(myProgramIdl as any);
  // registry.set(meta.programId, meta);

  return registry;
}

export const INSTRUCTION_REGISTRY: InstructionRegistry = buildRegistry();

export function lookupProgram(programId: string): ProgramMeta | undefined {
  return INSTRUCTION_REGISTRY.get(programId);
}

export function lookupInstruction(
  programId: string,
  discriminatorHex: string,
): InstructionMeta | undefined {
  return INSTRUCTION_REGISTRY.get(programId)?.instructions.get(
    discriminatorHex,
  );
}

export function getProgramDisplayName(programId: string): string {
  const meta = INSTRUCTION_REGISTRY.get(programId);
  if (meta) return meta.displayName;
  return `${programId.slice(0, 4)}...${programId.slice(-4)}`;
}

export function getInstructionDisplayName(
  programId: string,
  discriminatorHex: string,
): string {
  const meta = lookupInstruction(programId, discriminatorHex);
  if (meta) return meta.displayName;
  return `0x${discriminatorHex}`;
}

export { discriminatorToHex };
